import { render } from "./App.vue?vue&type=template&id=144d55a4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=144d55a4&lang=css"

import exportComponent from "/home/isa/qrcode-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__